const $ = window.jQuery;
const $window = window.$window || $(window);

const TempInsuranceRegCheck = {

  init() {

    //var storedINT; //temp till this is added
    var int = $.getQuery('int');
    var storedINT;
    if (storage) {
      storedINT = storage.getItem('int');
    } else {
      storedINT = int;
    }

    // Registration search on temp insurance landing
    $('.checkRegPresent').on('click', function (event) {
      event.preventDefault();
      let href = "https://shortterm.ingenie.com";
      let str = $('#vehicle-reg').val().replace(/\s+/g, '').toUpperCase();
      let registration = str.substr(0, 7);
      var validateReg = /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/;
      // source https://gist.github.com/danielrbradley/7567269

      console.log("registration being checked", registration);
      // console.log("HREF", href);
      if (registration == '') {
        $('#reg-error').fadeIn();
        scrollUpToRegError();
        return false;
      } else if (!(validateReg.test(registration))) {
        $('#reg-error-invalid').fadeIn();
        scrollUpToRegError();
        return false;
      } else if (storedINT) {
        $('#reg-error').fadeOut();
        $('#reg-error-invalid').fadeOut();
        let builthref = href + "?reg=" + registration + '&int=' + storedINT;
        window.open(
          builthref,
          '_blank'
        );
      } else {
        $('#reg-error').fadeOut();
        $('#reg-error-invalid').fadeOut();
        let builthref = href + "?reg=" + registration
        window.open(
          builthref,
          '_blank'
        );
      }
    });

    $("#vehicle-reg").keyup(function () {
      var input = $(this);
      if (input.val() == "") {
        $('#reg-error').fadeOut();
        $('#reg-error-invalid').fadeOut();
      }
    });

    const scrollUpToRegError = function () {
      $('html, body').animate({
        scrollTop: $("#regForm").offset().top
      }, 400);
    }

    // Get URL Parameters
    !function (e) { e.getQuery = function (e) { e = e.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); var n = '[\\?&]' + e + '=([^&#]*)', r = new RegExp(n), c = r.exec(window.location.href); return null !== c ? c[1] : !1 } }(jQuery);

    // Sessionstorage
    var storage = (function () {
      var uid = new Date;
      var storage;
      var result;
      try {
        (storage = window.sessionStorage).setItem(uid, uid);
        result = storage.getItem(uid) == uid;
        storage.removeItem(uid);
        return result && storage;
      } catch (exception) { }
    }());

  }



};

export default TempInsuranceRegCheck;